import React,{useEffect,useState} from "react";
import { useNavigate } from "react-router-dom";
import useChatStore from "../../store/useChatStore";

const ChatHeader = () =>{
    const [showNumber, setShowNumber] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const navigate = useNavigate();
    const logout = useChatStore((state) => state.logout); // ✅ Get logout function

    const handleLogout = () => {
        logout(); // ✅ Clear session data
        navigate("/"); // ✅ Redirect to home
    };

    useEffect(() => {
        // Detect if the user is on a mobile device
        const checkIfMobile = () => {
        setIsMobile(/Mobi|Android/i.test(navigator.userAgent));
    };

    checkIfMobile();

    // Optionally update state on window resize
    window.addEventListener("resize", checkIfMobile);
        return () => window.removeEventListener("resize", checkIfMobile);
    }, []);

    const handleWhatsAppClick = () => {
        if (!isMobile) {
            // Redirect to WhatsApp link on mobile
            window.location.href = `https://wa.me/9662267474`;
        } else {
            // Show number on desktop
            setShowNumber(true);

            // Hide the number and show the icon back after 15 seconds
            setTimeout(() => {
                setShowNumber(false);
            }, 15000);
        }
    };
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen); // Toggle dropdown visibility
    };
    return(
        <nav className="chatbot-header">
            <div className="chatbot-header-section">
                <div className="left-chatbot-header-section">
                    <img src="/images/growbizh-logo.png"  alt="growbizh-logo"/>
                </div>
                <div className="right-chatbot-header-section">
                {!showNumber && (
                    <div className="right-chatbot-header-whatsapp-section"
                     onClick={handleWhatsAppClick}
                     style={{ cursor: "pointer" }}
                     >
                        <img src="/images/whatsapp-connect-now-button.png" alt="whatsapp-logo"/>
                    </div>
                    )}
                    {/* Conditionally render the phone number */}
                    {showNumber && !isMobile && (
                    <div className="whatsapp-number">9662267474</div>
                    )}
                    <div className="right-chatbot-header-profile-section" 
                         onMouseLeave={() => setDropdownOpen(false)}
                    >
                       <img src="/images/profile-icon.png" alt="profile-logo" onClick={toggleDropdown} className="profile-icon"/>
                        {dropdownOpen && (
                        <div className="dropdown-content">
                            <a href="/" onClick={handleLogout}>
                            <img src="/images/logout-icon.png" alt="logout-icon"/>
                            Logout</a>
                            <a href="/bizzie" >
                            <img src="/images/language-globe-icon.png" alt="language-icon"/>
                            English</a>
                            <a href="/" >
                            <img src="/images/setting-icon.png" alt="setting-icon"/>
                            Setting</a>
                        </div>
                    )}
                    </div>
                </div>
            </div>

        </nav>
    )
}


export default ChatHeader;